/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { /*useHistory,*/ useLocation } from 'react-router-dom';
import TextFields from '../common/components/TextField/TextField';
import Link from '../common/Link';
import { useAuth } from '../context/auth-context';
//import { translateErrors } from '../utils';

const resetError = {
    email: {
        hasError: false,
        message: '',
    },
    password: {
        hasError: false,
        message: '',
    },
    name: {
        hasError: false,
        message: '',
    },
    lastName: {
        hasError: false,
        message: '',
    },
    phone: {
        hasError: false,
        message: '',
    },
    code: {
        hasError: false,
        message: '',
    },
    terms: {
        hasError: false,
        message: '',
    },
};

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const FormConfirmCode = (): JSX.Element => {
    const [error, setError] = useState(resetError);
    const [errorRegister, setErrorRegister] = useState('');
    const query = useQuery();
    const email = query.get('email');
    const code = query.get('code');
    //const code = query.get('code');
    const [values, setValues] = useState({
        name: '',
        lastName: '',
        email: email ? email : '',
        password: '',
        phone: '',
        code: code ? code : '',
        terms: true,
    });

    const auth = useAuth();

    const [statusConfirmCode, setStatusConfirmCode] = useState(false);

    const validateEmail = (email) => {
        const re = /\S+@\S+\.\S+/;
        return re.test(email);
    };

    const handlerConfirmCode = async (e: React.SyntheticEvent) => {
        e.preventDefault();
        // handleCodeActive();
        //   console.log('llegue handlerConfirmCode', { values });

        if (values && values.code === '') {
            setError({
                ...error,
                code: {
                    hasError: true,
                    message: 'Codigo requeridao',
                },
            });
        }

        if (values && values.email === '') {
            setError({
                ...error,
                email: {
                    hasError: true,
                    message: '¡Email es requerido!',
                },
            });
        }

        if (values && values.email !== '' && !validateEmail(values.email)) {
            setError({
                ...error,
                email: {
                    hasError: true,
                    message: '¡Email no es valido!',
                },
            });
        }

        try {
            if (values && values.email !== '' && values.code !== '') {
                // console.log(' //aqui la validacion con congnito');
                await auth.confirmCode(values.email, values.code);
                setError(resetError);
            }
        } catch (error) {
            setErrorRegister('');
            console.log({ error });
            setErrorRegister('¡No se puede confirmar el codigo  del usuario, intente nuevamente!');
        }
    };

    const handleChangeEmail = (e: any) => {
        setErrorRegister('');
        if (e.target.value.trim() === '') {
            auth.clearErrorAuth();
        }
        setError({
            ...error,
            email: {
                hasError: false,
                message: '',
            },
        });
        setValues({ ...values, email: e.target.value.trim() });
    };

    const handleChangeCode = (e: any) => {
        setErrorRegister('');
        if (e.target.value.trim() === '') {
            auth.clearErrorAuth();
        }
        setError({
            ...error,
            code: {
                hasError: false,
                message: '',
            },
        });
        setValues({ ...values, code: e.target.value });
    };

    useEffect(() => {
        if (auth.error) {
            console.log('error', auth.error, auth.error.statusCode);
            if (auth.error.statusCode === 'NotAuthorizedExceptionConfirmed') {
                setErrorRegister('Error: Este usuario ya se encuentra CONFIRMADO, haz click en ¿Ya tienes cuenta?');
            } else if (auth.error.statusCode === 'InvalidParameterException') {
                setErrorRegister(
                    'Error: Parametros incorrectos, vuelva a ingresar el email y el codigo enviado a su correo',
                );
            } else if (auth.error.statusCode === 'UserNotConfirmedException') {
                setErrorRegister('Error: Usuario no Confirmado');
            } else if (auth.error.statusCode === 'UserNotFoundException') {
                setErrorRegister('Error: Correo invalido');
            } else if (auth.error.statusCode === 'CodeMismatchException') {
                // setErrorCode(true);
                setErrorRegister('Error: Codigo Invalido');
            } else {
                setErrorRegister('Error: Vuelva Intentar');
            }
        } else {
            //console.log('auth', { auth });
            if (auth.codeConfirmOk) {
                setStatusConfirmCode(true);
                //console.log('positivo');
            }
            setErrorRegister('');
        }
    }, [auth]);

    useEffect(() => {
        //  auth.clearErrorAuth();
    }, []);

    useEffect(() => {
        setValues({
            name: '',
            lastName: '',
            email: email ? email.trim() : '',
            phone: '',
            terms: true,
            code: code ? code : '',
            password: '',
        });
    }, [email, code]);

    return (
        <>
            <form className="flex flex-col mb-2" onSubmit={handlerConfirmCode}>
                {statusConfirmCode ? (
                    <>
                        <div className={`w-full  flex flex-col text-white font-bold text-xl text-center`}>
                            <p className="flex-col mb-6  pt-10 ">
                                Felicitaciones tu registro fue realizado Correctamente{' '}
                            </p>
                            <Link
                                to={'/login?email=' + values.email}
                                className="underline"
                                href={'/login?email=' + values.email}
                            >
                                ingresa aquí.
                            </Link>
                        </div>
                    </>
                ) : (
                    <>
                        <div className={`w-full text-center`}>
                            <p className={`text-sm text-white`}>
                                Gracias por registrarte, se envió a tu Email un codigo de validación
                            </p>
                            <p className={`text-sm text-white`}>
                                Ingresalo en el campo código y presiona el botón validar
                            </p>
                        </div>
                        <TextFields
                            name={'email'}
                            id={'email'}
                            path={
                                'M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z'
                            }
                            label={'Email'}
                            type={'text'}
                            value={values.email}
                            placeholder={'Email'}
                            hasError={error.email.hasError}
                            messageError={error.email.message}
                            onChange={handleChangeEmail}
                            background={'dark'}
                        />
                        <TextFields
                            autoFocus={true}
                            name={'code'}
                            id={'code'}
                            path={
                                'M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z'
                            }
                            label={'Código'}
                            type={'text'}
                            value={values.code}
                            placeholder={'Código'}
                            hasError={error.code.hasError}
                            messageError={error.code.message}
                            onChange={handleChangeCode}
                            background={'dark'}
                        />
                    </>
                )}
                {errorRegister && <p className="mb-6 text-base text-red-200">{errorRegister}</p>}

                {!statusConfirmCode && (
                    <button
                        type="submit"
                        className={`w-full relative text-white px-4 py-4 rounded-lg text-lg mb-6 bg-sm-integrate`}
                        disabled={false}
                    >
                        {'Validar'}
                    </button>
                )}
            </form>
            {!statusConfirmCode && (
                <div className={`w-full text-center`}>
                    <Link to="/login">
                        <p className={`text-sm text-white`}>¿Ya tienes cuenta?</p>
                    </Link>
                    <Link to="/registro">
                        <p className={`text-sm text-white pt-5`}>¿Formulario de Registro?</p>
                    </Link>
                </div>
            )}
        </>
    );
};

export default FormConfirmCode;
